// extracted by mini-css-extract-plugin
export default {"integrationsContainer":"style_integrationsContainer__PznAN","list":"style_list__-IPpc","empty":"style_empty__zua26"};